import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
import { computed, toRef } from "vue";
import { categorizeComponentVariables } from "..";
import { isComponentVariablePrimaryCategoryShown, isComponentVariableSecondaryCategoryShown, isComponentVariableSecondaryCategoryDisplayNameShown, } from "../filter/isComponentVariableShown";
import { useComponentMutable } from "src/shared/store/component-mutable/composables/useComponentMutable";
import ComponentVariable from "../../item/ComponentVariable.vue";
import { useComponentVariableSearchables } from "src/shared/store/component-variable-searchable/composables/useComponentVariableSearchables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableListStandardCategorized',
    props: {
        componentMutableKey: {},
        hiddenVariableNames: {},
        isMasked: { type: Boolean },
        componentDrawerRouteConfig: {}
    },
    setup(__props) {
        const props = __props;
        const { componentMutable } = useComponentMutable(toRef(props, "componentMutableKey"));
        const componentId = computed(() => {
            var _a;
            return (_a = componentMutable.value) === null || _a === void 0 ? void 0 : _a.component_id;
        });
        const { componentVariableSearchables } = useComponentVariableSearchables(componentId);
        const variablesWithoutHidden = computed(() => {
            return componentVariableSearchables.value.filter((variable) => { var _a; return !((_a = props.hiddenVariableNames) === null || _a === void 0 ? void 0 : _a.includes(variable.name)); });
        });
        const categorizedVariables = computed(() => {
            return categorizeComponentVariables(variablesWithoutHidden.value);
        });
        return (_ctx, _cache) => {
            return (componentId.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["component-variable-list-v2 component-variable-list--standard-categorized", { 'component-variable-list--masked': _ctx.isMasked }])
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorizedVariables.value, (primaryCategory) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                            class: "component-variable-list__primary-category",
                            key: primaryCategory.name
                        }, [
                            (!primaryCategory.isOther())
                                ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(primaryCategory.getDisplayName()), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(primaryCategory.secondaryCategories, (secondaryCategory) => {
                                return _withDirectives((_openBlock(), _createElementBlock("div", {
                                    class: "component-variable-list__primary-category__secondary-category",
                                    key: secondaryCategory.name
                                }, [
                                    _withDirectives(_createElementVNode("h2", null, _toDisplayString(secondaryCategory.getDisplayName()), 513 /* TEXT, NEED_PATCH */), [
                                        [_vShow,
                                            _unref(isComponentVariableSecondaryCategoryDisplayNameShown)(primaryCategory.secondaryCategories.length === 1, secondaryCategory.getDisplayName())
                                        ]
                                    ]),
                                    (secondaryCategory.variables.basic.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondaryCategory.variables.basic, (variable) => {
                                                return (_openBlock(), _createBlock(ComponentVariable, {
                                                    key: variable.name,
                                                    "component-id": variable.componentId,
                                                    "variable-name": variable.name,
                                                    "component-mutable-key": _ctx.componentMutableKey,
                                                    componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                                                }, null, 8 /* PROPS */, ["component-id", "variable-name", "component-mutable-key", "componentDrawerRouteConfig"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (secondaryCategory.variables.advanced.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondaryCategory.variables.advanced, (variable) => {
                                                return (_openBlock(), _createBlock(ComponentVariable, {
                                                    key: variable.name,
                                                    "component-id": variable.componentId,
                                                    "variable-name": variable.name,
                                                    "component-mutable-key": _ctx.componentMutableKey,
                                                    componentDrawerRouteConfig: _ctx.componentDrawerRouteConfig
                                                }, null, 8 /* PROPS */, ["component-id", "variable-name", "component-mutable-key", "componentDrawerRouteConfig"]));
                                            }), 128 /* KEYED_FRAGMENT */))
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])), [
                                    [_vShow,
                                        _unref(isComponentVariableSecondaryCategoryShown)(secondaryCategory.name, _ctx.componentMutableKey)
                                    ]
                                ]);
                            }), 128 /* KEYED_FRAGMENT */))
                        ])), [
                            [_vShow,
                                _unref(isComponentVariablePrimaryCategoryShown)(primaryCategory.name, _ctx.componentMutableKey)
                            ]
                        ]);
                    }), 128 /* KEYED_FRAGMENT */))
                ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true);
        };
    }
});
